
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerClass()
    export class OverlayAccountGrid extends SiteEntityGrid<OverlayAccountRow, any> {
        protected getColumnsKey() { return 'Rebalancer.OverlayAccount'; }
        protected getDialogType() { return OverlayAccountDialog; }
        protected getIdProperty() { return OverlayAccountRow.idProperty; }
        protected getLocalTextPrefix() { return OverlayAccountRow.localTextPrefix; }
        protected getService() { return OverlayAccountService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}